// GenieX Shop — PayU Affordability Widget (EMI/BNPL offers), checkout payment step.
// Loads PayU's hosted SDK and mounts it into the fixed #payuWidget container.
import { useEffect, useRef } from "react";
import { shopApi } from "./api";

const SCRIPT_ID = "payu-affordability-widget";
const SCRIPT_SRC = "https://jssdk.payu.in/widget/affordability-widget.min.js";

function loadPayUScript() {
  return new Promise((resolve, reject) => {
    if (window.payuAffordability) return resolve();
    let script = document.getElementById(SCRIPT_ID);
    if (!script) {
      script = document.createElement("script");
      script.id = SCRIPT_ID;
      script.src = SCRIPT_SRC;
      script.async = true;
      document.body.appendChild(script);
    }
    script.addEventListener("load", resolve, { once: true });
    script.addEventListener("error", () => reject(new Error("PayU SDK failed to load")), { once: true });
  });
}

export function PayuAffordabilityWidget({ amount }) {
  const initializedAmount = useRef(null);

  useEffect(() => {
    let cancelled = false;
    const normalizedAmount = String(amount);

    async function initialize() {
      try {
        const { data } = await shopApi.get("/shop/payu-widget-key");
        const merchantKey = data?.merchant_key;
        await loadPayUScript();
        if (cancelled || !window.payuAffordability) return;

        const mount = document.getElementById("payuWidget");
        if (!mount || !merchantKey || Number(normalizedAmount) <= 0) return;
        if (initializedAmount.current === normalizedAmount) return;
        initializedAmount.current = normalizedAmount;

        mount.replaceChildren();
        window.payuAffordability.init({ key: merchantKey, amount: normalizedAmount });
      } catch (err) {
        console.error("PayU affordability widget failed to load", err);
      }
    }

    initialize();
    return () => {
      cancelled = true;
    };
  }, [amount]);

  return <div id="payuWidget" data-testid="payu-affordability-widget" aria-live="polite" />;
}
